export default __webpack_public_path__ + "static/media/avatar15.716ad2b0.png";